import React, { useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogContent,
    DialogActions,
    IconButton,
    Typography,
    useMediaQuery,
    useTheme,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const SizeChartDialog = ({ imageSrc }) => {
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    return (
        <Box sx={{ textAlign: "left", mt: 2 }}>
            {/* Size Chart Button */}
            <Button
                variant="outlined"
                onClick={handleOpen}
                sx={{
                    textTransform: "none",
                    borderRadius: 1,
                    //   fontSize: { xs: "0.9rem", sm: "1rem" },
                    //   px: { xs: 2, sm: 3 },
                    //   py: { xs: 1, sm: 1.2 },
                }}
            >
                Size Chart
            </Button>

            {/* Dialog */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullScreen={fullScreen}
                maxWidth="xs"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: { xs: 0, sm: 3 },
                        p: { xs: 1, sm: 2 },
                    },
                }}
            >
                {/* Close Icon */}
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        color: "grey.700",
                        zIndex: 10,
                    }}
                >
                    <CloseIcon />
                </IconButton>

                {/* Dialog Content */}
                <DialogContent
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        p: { xs: 2, sm: 3 },
                    }}
                >
                    <Typography
                        variant="h6"
                        sx={{
                            mb: 2,
                            fontSize: { xs: "1rem", sm: "1.25rem" },
                            fontWeight: 600,
                        }}
                    >
                        Size Chart
                    </Typography>

                    <Box
                        component="img"
                        src={imageSrc}
                        alt="Size Chart"
                        sx={{
                            maxWidth: "100%",
                            height: "auto",
                            borderRadius: 2,
                            boxShadow: 1,
                            objectFit: "contain",
                        }}
                    />
                </DialogContent>

                {/* Close Button */}
                <DialogActions sx={{ justifyContent: "center", pb: 2 }}>
                    <Button
                        onClick={handleClose}
                        variant="contained"
                        sx={{
                            textTransform: "none",
                            borderRadius: 2,
                            fontSize: { xs: "0.9rem", sm: "1rem" },
                            px: 3,
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default SizeChartDialog;
